import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Paper,
  Typography,
} from '@mui/material';

import React, { useState, useRef } from 'react';
import { useStore } from '../../utils/store';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import {
  getFormatDate,
  getFormatDateTime,
  getShiftStatusText,
  getStoredMenuItems,
} from '../../utils/storageUtil';

interface StatusActivityProps {
  currentRecord: any;

  goBack: () => void;
}
const StatusActivity: React.FC<StatusActivityProps> = ({
  currentRecord,

  goBack,
}) => {
  const isInitialLoad = useRef(true);
  const [inProgress, setInProgress] = useState(false);
  const [ShiftStatusActivityList, SetShiftStatusActivityList] = useState<any[]>(
    []
  );
  const { getAdmin } = useStore();
  const [httpError, setHttpError] = useState({
    message: '',
    open: false,
  });

  return (
    <Paper sx={{ width: '100%' }} elevation={0} className="mt-4">
      <Box
        sx={{
          padding: '24px 16px 16px 16px',
          mb: 2,
          display: 'grid',
          gap: '32px',
        }}
      >
        <Typography variant="h6"> Status </Typography>

        <Box>
          {currentRecord && (
            <Card sx={{ minWidth: 275 }}>
              <CardContent>
                <Typography
                  gutterBottom
                  sx={{ color: 'text.secondary', fontSize: 18 }}
                >
                  Current Status{' '}
                  <Chip
                    sx={{ marginLeft: '10px' }}
                    color="primary"
                    label={getShiftStatusText(currentRecord.shiftStatusId)}
                  />
                </Typography>
                <Divider />
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: '20px', marginBottom: '20px' }}
                >
                  Shift Activity
                  <p style={{ fontSize: '14px', color: '#666666' }}>
                    All actions performed on this task will be recorded below
                  </p>
                </Typography>
                {currentRecord.shiftStatusActivity.length > 0 &&
                  currentRecord.shiftStatusActivity[0].User && (
                    <Box>
                      <Typography>
                        Shift Created By{' '}
                        {currentRecord.shiftStatusActivity[0].User.firstName +
                          ' ' +
                          currentRecord.shiftStatusActivity[0].User.lastName}
                      </Typography>
                      <Typography>
                        {getFormatDateTime(
                          currentRecord.shiftStatusActivity[0].created
                        )}
                      </Typography>
                    </Box>
                  )}
                {currentRecord.shiftStatusActivity.map(
                  (item: any, index: any) => {
                    return index > 0 ? (
                      item.User && (
                        <Box>
                          <Typography
                            sx={{ marginTop: '10px', marginBottom: '10px' }}
                          >
                            {'Shift '}
                            {(item.shiftStatusId === 0
                              ? ' Updated '
                              : getShiftStatusText(item.shiftStatusId)) +
                              ' By ' +
                              item.User.firstName +
                              ' ' +
                              item.User.lastName}
                          </Typography>
                          <Typography>
                            {getFormatDateTime(item.created)}
                          </Typography>
                        </Box>
                      )
                    ) : (
                      <span></span>
                    );
                  }
                )}
              </CardContent>
            </Card>
          )}
        </Box>

        <AlertMessageComponent
          type={'success'}
          open={httpError.open}
          handleClose={() => {
            setHttpError({ open: false, message: '' });
          }}
          message={httpError.message}
        />
      </Box>
    </Paper>
  );
};

export default StatusActivity;
const boxStyle = {
  marginBottom: '15px',
};
